/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request challenge.
 * @export
 * @interface ChallengeRequestRequest
 */
export interface ChallengeRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof ChallengeRequestRequest
     */
    deviceId: string;
}

/**
 * Check if a given object implements the ChallengeRequestRequest interface.
 */
export function instanceOfChallengeRequestRequest(value: object): value is ChallengeRequestRequest {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    return true;
}

export function ChallengeRequestRequestFromJSON(json: any): ChallengeRequestRequest {
    return ChallengeRequestRequestFromJSONTyped(json, false);
}

export function ChallengeRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
    };
}

export function ChallengeRequestRequestToJSON(json: any): ChallengeRequestRequest {
    return ChallengeRequestRequestToJSONTyped(json, false);
}

export function ChallengeRequestRequestToJSONTyped(value?: ChallengeRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
    };
}

